import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQueryClient } = ReactQueryV5;
import { useMindlerApi } from "api/apiv2";
import { getTemplate } from "helpers/templates";
import { getUnixTime } from "date-fns";
import { type Event, type SlotApiRes, type Template } from "core/types";
import { useCallback } from "react";

type Args = {
  setEventDrop: (e: Event | null) => void;
  eventDragStartRef: React.RefObject<number | null>;
};

export const useHandleEventDrop = ({
  setEventDrop,
  eventDragStartRef,
}: Args) => {
  const queryClient = useQueryClient();
  const api = useMindlerApi();

  return useCallback(
    (eventDrop: Event | null, templates: Template[]) => {
      if (eventDrop === null) {
        setEventDrop(null);
        return;
      }

      const gotTemplate = getTemplate(eventDrop.event.templateId, templates);

      if (
        !gotTemplate?.allowCustomLength &&
        eventDragStartRef.current === getUnixTime(eventDrop.start as Date)
      ) {
        return;
      }

      const updatedSlot = {
        ...eventDrop.event,
        startsAt: getUnixTime(eventDrop.start as Date),
        endsAt: getUnixTime(eventDrop.end as Date),
      };

      queryClient.setQueriesData<SlotApiRes[]>(
        api.slots.psychologist.calendar.queryFilter(),
        (old) => {
          if (!old) return old;
          return [
            ...old.filter((slot) => slot.slotId !== eventDrop.event.slotId),
            updatedSlot as SlotApiRes,
          ];
        },
      );

      setEventDrop(eventDrop);
    },
    [setEventDrop, eventDragStartRef, queryClient, api],
  );
};
